// extracted by mini-css-extract-plugin
module.exports = {"marginsContainer":"MainWrapper_marginsContainer__2RemM","margin":"MainWrapper_margin__Tgs4y","contentWrapper":"MainWrapper_contentWrapper__39Yhf"};